import { render, staticRenderFns } from "./AddRoomDialog.vue?vue&type=template&id=5c520366&scoped=true"
import script from "@/views/Users/Teacher/AddRoomDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/Teacher/AddRoomDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/Teacher/add-room-dialog.scss?vue&type=style&index=0&id=5c520366&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c520366",
  null
  
)

export default component.exports